// A module-level handle to the live toast API, for the few non-React call sites that can't
// use the `useToast()` hook — specifically the module-level `window.fetch` wrappers in
// `app/`. `ToastProvider` registers itself on mount (and clears on unmount); every method
// no-ops until then, so importing this never forces a Toast dependency.

let sink = null

export const setToastSink = (api) => {
  sink = api
}

export const toastSink = {
  error: (message) => sink?.error(message),
  success: (message) => sink?.success(message),
  info: (message) => sink?.info(message),
  prompt: (message, options) => sink?.prompt(message, options),
}
